import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AUC_ENVIRONMENT } from "@auction-ui/environments/environment";
import { AucModule } from "@auction-ui/module";



if (AUC_ENVIRONMENT.production === true) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AucModule)
  .catch(err => console.error(err));